import {IndexedDbFactory} from "../database/IndexedDbFactory";
import {ServiceError} from "../../hooks/fetch/types";
import {Account} from "../../components/Account/types";


class AccountService {

    private static _instance: AccountService;

    private constructor() {
        //Private constructor to prevent direct instantiation
    }

    public static get Instance()
    {
        return this._instance || (this._instance = new this());
    }

    public async getAccount(): Promise<Account> {
        try {
            const account = await IndexedDbFactory.getInstance().get<Account>("keyvalue", "account");
            if (!account) {
                throw new ServiceError(404, 'Not Found', 'No account found');
            }
            return account;
        } catch (error) {
            if (error instanceof ServiceError) {
                throw error;
            }
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async save(account: Account): Promise<void> {
        try {
            await IndexedDbFactory.getInstance().set("keyvalue", account, "account");
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }

    public async remove(): Promise<void> {
        try {
            await IndexedDbFactory.getInstance().delete("keyvalue", "account");
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            throw new ServiceError(500, 'Internal Error', message);
        }
    }
}

export const accountService = AccountService.Instance;